// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  margin-right: 0.5rem;
}

.div1 {
  padding: 0.625rem;
  text-align: center;
  border-top: 1px solid lightgrey;
}

.p-bold {
  font-weight: bold;
  padding: 0.3125rem 0;
  margin: 0;
}

.p-normal {
  padding: 0.3125rem 0;
  margin: 0;
}

.mt-20 {
  margin-top: 1.25rem;
}

ion-button {
  --border-radius: 0;
}

.coupon-container .coupon-top-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.coupon-container .coupon-top-section .coupon-heading-class {
  font-weight: 700;
  font-size: 2.625rem;
  line-height: 100%;
  color: var(--ion-black-primary);
  padding: 1.75rem 0 1.5625rem 0;
}

.coupon-field-div {
  width: 49.2%;
}

.coupon-field {
  display: flex;
  place-content: space-between;
  margin-bottom: 20px;
}

.back-btn {
  width: 100px;
  height: 46px;
  background: #0081ca;
  font: normal normal bold 15px/20px Noto Sans;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-transform: uppercase;
}

.back-btn-ltr {
  float: right;
}

.back-btn-rtl {
  float: left;
}

ion-input {
  pointer-events: none;
}

.listing-table {
  margin: 2.25rem 0 1.25rem;
  overflow-x: auto;
}
.listing-table .table {
  width: 100%;
}
.listing-table .table .column-heading {
  font-weight: 400;
  font-size: 0.975rem;
  line-height: 1.125rem;
  font-weight: bold;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.75rem 0.5625rem 0.75rem 0;
}
.listing-table .table .status-col {
  max-width: 130px;
  width: 130px;
  min-width: 130px;
}
.listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.listing-table .table .product-id {
  font-weight: bold;
  line-height: 1.5rem;
  font-size: 1rem;
  color: var(--ion-color-primary-black);
  opacity: 1;
  margin-left: 0.375rem;
}
.listing-table .table .table-body {
  font-weight: normal;
  line-height: 1.3125rem;
  font-size: 1rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.listing-table .table .table-body .table-row td {
  padding: 0.4375rem 0.5625rem 0.1875rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--ion-color-primary-black);
}
.listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}

.prodImg {
  height: 100px;
  width: 100px;
}

.sr-no-col {
  min-width: 50px;
}

.id-col {
  min-width: 80px;
}

.img-col {
  min-width: 110px;
}

.name-col {
  min-width: 135px;
}

.customer-col {
  min-width: 100px;
}

.email-col {
  min-width: 140px;
}

.updated-at-col {
  min-width: 120px;
}

.ship-to-col {
  min-width: 300px;
}

.date-col {
  min-width: 130px;
}

.reason-of-cancel-col {
  min-width: 130px;
}

.qty-col {
  min-width: 70px;
}

.thead {
  border-bottom: 1px solid var(--ion-color-primary-border);
  font-weight: 500;
  line-height: 0.875rem;
  font-size: 0.72rem;
  color: var(--ion-color-secondary-black);
  text-transform: uppercase;
  opacity: 1;
}

.pagination-wrapper {
  max-width: 1400px;
  margin: auto;
  text-align: center;
}

.pagination-div {
  align-items: center;
}

.pagination-grid {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 1.25rem 0;
}
.pagination-grid-tile {
  width: 33%;
  padding: 0;
}

.perpage-dropdown {
  display: flex;
  align-items: center;
}
.perpage-dropdown ion-item {
  font-weight: bold;
  line-height: 1.3125rem;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

.perpage-title {
  font-weight: normal;
  line-height: 1.3125rem;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

ion-select.LTR::part(icon) {
  opacity: 1;
  color: transparent;
  margin-left: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

ion-select.RTL::part(icon) {
  opacity: 1;
  color: transparent;
  margin-right: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.pagination-col {
  text-align: end;
}

.form-inputs ion-label {
  text-transform: uppercase !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/coupon-details/coupon-details.component.scss"],"names":[],"mappings":"AAAA;EACC,oBAAA;AACD;;AAEA;EACC,iBAAA;EACA,kBAAA;EACA,+BAAA;AACD;;AAEA;EACC,iBAAA;EACA,oBAAA;EACA,SAAA;AACD;;AAEA;EACC,oBAAA;EACA,SAAA;AACD;;AAEA;EACC,mBAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAGC;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAAF;AAEE;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAAA;EACA,8BAAA;AAAH;;AAKA;EACC,YAAA;AAFD;;AAKA;EACC,aAAA;EACA,4BAAA;EACA,mBAAA;AAFD;;AAKA;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAFD;;AAOA;EACC,YAAA;AAJD;;AAOA;EACC,WAAA;AAJD;;AAOA;EACC,oBAAA;AAJD;;AAOA;EACC,yBAAA;EACA,gBAAA;AAJD;AAMC;EACC,WAAA;AAJF;AAME;EACC,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uCAAA;EACA,oCAAA;AAJH;AAOE;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;AALH;AAQE;EACC,gBAAA;EACA,gBAAA;AANH;AASE;EACC,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,qCAAA;EACA,UAAA;EACA,qBAAA;AAPH;AAUE;EACC,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AARH;AAUG;EACC,wDAAA;AARJ;AAUI;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AARL;AAWI;EACC,aAAA;EACA,mBAAA;AATL;;AAiBA;EACC,aAAA;EACA,YAAA;AAdD;;AAiBA;EACC,eAAA;AAdD;;AAiBA;EACC,eAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,gBAAA;AAdD;;AAiBA;EACC,eAAA;AAdD;;AAiBA;EACC,wDAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,yBAAA;EACA,UAAA;AAdD;;AAiBA;EACC,iBAAA;EACA,YAAA;EACA,kBAAA;AAdD;;AAiBA;EACC,mBAAA;AAdD;;AAiBA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAdD;AAgBC;EACC,UAAA;EACA,UAAA;AAdF;;AAkBA;EACC,aAAA;EACA,mBAAA;AAfD;AAiBC;EACC,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAfF;;AAmBA;EACC,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAhBD;;AAmBA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,wEAAA;AAhBD;;AAmBA;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,wEAAA;AAhBD;;AAmBA;EACC,eAAA;AAhBD;;AAoBC;EACC,oCAAA;AAjBF","sourcesContent":["button {\n\tmargin-right: 0.5rem;\n}\n\n.div1 {\n\tpadding: 0.625rem;\n\ttext-align: center;\n\tborder-top: 1px solid lightgrey\n}\n\n.p-bold {\n\tfont-weight: bold;\n\tpadding: 0.3125rem 0;\n\tmargin: 0;\n}\n\n.p-normal {\n\tpadding: 0.3125rem 0;\n\tmargin: 0;\n}\n\n.mt-20 {\n\tmargin-top: 1.25rem;\n}\n\nion-button {\n\t--border-radius: 0;\n}\n\n.coupon-container {\n\t.coupon-top-section {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 100%;\n\t\talign-items: center;\n\n\t\t.coupon-heading-class {\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 2.625rem;\n\t\t\tline-height: 100%;\n\t\t\tcolor: var(--ion-black-primary);\n\t\t\tpadding: 1.75rem 0 1.5625rem 0;\n\t\t}\n\t}\n}\n\n.coupon-field-div {\n\twidth: 49.2%;\n}\n\n.coupon-field {\n\tdisplay: flex;\n\tplace-content: space-between;\n\tmargin-bottom: 20px;\n}\n\n.back-btn {\n\twidth: 100px;\n\theight: 46px;\n\tbackground: #0081ca;\n\tfont: normal normal bold 15px/20px Noto Sans;\n\tletter-spacing: 0px;\n\tcolor: #FFFFFF;\n\ttext-transform: uppercase;\n}\n\n\n\n.back-btn-ltr {\n\tfloat: right;\n}\n\n.back-btn-rtl {\n\tfloat: left;\n}\n\nion-input {\n\tpointer-events: none;\n}\n\n.listing-table {\n\tmargin: 2.25rem 0 1.25rem;\n\toverflow-x: auto;\n\n\t.table {\n\t\twidth: 100%;\n\n\t\t.column-heading {\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 0.975rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tfont-weight: bold;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\tpadding: 0.75rem 0.5625rem 0.75rem 0;\n\t\t}\n\n\t\t.status-col {\n\t\t\tmax-width: 130px;\n\t\t\twidth: 130px;\n\t\t\tmin-width: 130px;\n\t\t}\n\n\t\t.ship-to-col {\n\t\t\tmin-width: 100px;\n\t\t\tmax-width: 244px;\n\t\t}\n\n\t\t.product-id {\n\t\t\tfont-weight: bold;\n\t\t\tline-height: 1.5rem;\n\t\t\tfont-size: 1rem;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\topacity: 1;\n\t\t\tmargin-left: 0.375rem;\n\t\t}\n\n\t\t.table-body {\n\t\t\tfont-weight: normal;\n\t\t\tline-height: 1.3125rem;\n\t\t\tfont-size: 1rem;\n\t\t\tletter-spacing: 0;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\topacity: 1;\n\n\t\t\t.table-row {\n\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\ttd {\n\t\t\t\t\tpadding: 0.4375rem 0.5625rem 0.1875rem 0;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 1.375rem;\n\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t}\n\n\t\t\t\t.right-arrow {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\t}\n}\n\n.prodImg {\n\theight: 100px;\n\twidth: 100px;\n}\n\n.sr-no-col {\n\tmin-width: 50px;\n}\n\n.id-col {\n\tmin-width: 80px;\n}\n\n.img-col {\n\tmin-width: 110px;\n}\n\n.name-col {\n\tmin-width: 135px;\n}\n\n.customer-col {\n\tmin-width: 100px;\n}\n\n.email-col {\n\tmin-width: 140px;\n}\n\n.updated-at-col {\n\tmin-width: 120px;\n}\n\n.ship-to-col {\n\tmin-width: 300px;\n}\n\n.date-col {\n\tmin-width: 130px;\n}\n\n.reason-of-cancel-col {\n\tmin-width: 130px;\n}\n\n.qty-col {\n\tmin-width: 70px;\n}\n\n.thead {\n\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\tfont-weight: 500;\n\tline-height: 0.875rem;\n\tfont-size: 0.72rem;\n\tcolor: var(--ion-color-secondary-black);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.pagination-wrapper {\n\tmax-width: 1400px;\n\tmargin: auto;\n\ttext-align: center;\n}\n\n.pagination-div {\n\talign-items: center;\n}\n\n.pagination-grid {\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: space-between;\n\tmargin: 1.25rem 0;\n\n\t&-tile {\n\t\twidth: 33%;\n\t\tpadding: 0;\n\t}\n}\n\n.perpage-dropdown {\n\tdisplay: flex;\n\talign-items: center;\n\n\tion-item {\n\t\tfont-weight: bold;\n\t\tline-height: 1.3125rem;\n\t\tfont-size: 0.875rem;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n}\n\n.perpage-title {\n\tfont-weight: normal;\n\tline-height: 1.3125rem;\n\tfont-size: 0.875rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n}\n\nion-select.LTR::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-left: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\nion-select.RTL::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-right: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.pagination-col {\n\ttext-align: end;\n}\n\n.form-inputs {\n\tion-label {\n\t\ttext-transform: uppercase !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
